<ng-container *transloco="let t; read: 'collection-upload'">
  <div class="content-padding">
    @if (uploader?.queue?.length === 0) {
      <div class="collection-upload__back-to-project">
        <a
          [routerLink]="[getRouteToProject()]"
          class="collection-upload__back-to-project kxi-text-600 kxi-text-small"
        >
          <xi-icon icon="arrow_left" color="CX"></xi-icon>{{ t('back-to-project') }}
        </a>
      </div>
    }
    <div class="collection-upload__header">
      <h1 class="kxi-text-600">{{ t('add-new-file') }}</h1>
    </div>

    <div class="collection-upload__sub-header">
      <h3 class="kxi-text-600 collection-upload__uploading-to">
        <span>{{ t('uploading-to') }}: </span>{{ selectedDisplayName }}
      </h3>
      <div>
        @if (advancedSettings) {
          <div class="kxi-button collection-upload__advanced-settings-info">
            <xi-icon icon="info"></xi-icon>
            @if (advancedSettings.toUpload) {
              <p>
                {{ t('upload') }}:
                <b>{{ t('upload-rows', { toUpload: advancedSettings.toUpload }) }}</b>
              </p>
            }
            @if (advancedSettings.toUpload && advancedSettings.toSkip) {
              <p class="collection-upload__advanced-settings-separator">|</p>
            }
            @if (advancedSettings.toSkip) {
              <p>
                {{ t('skip') }}: <b>{{ t('skip-rows', { toSkip: advancedSettings.toSkip }) }}</b>
              </p>
            }
          </div>
        }
        <xi-default-button
          iconLeft="settings"
          [text]="t('advanced-upload-options')"
          fill="text"
          (onClick)="showAdvancedOptionsDialog()"
        >
        </xi-default-button>
      </div>
    </div>

    @if (uploader?.queue?.length === 0) {
      <div class="collection-upload__upload-container">
        <div
          ng2FileDrop
          class="collection-upload__well"
          [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
          [uploader]="uploader"
          (fileOver)="fileOverBase($event)"
          (onFileDrop)="validateSelectedFiles($event)"
        >
          <div class="collection-upload__upload-icon"><xi-svg svg="plus"></xi-svg></div>
          <div class="collection-upload__drag-and-drop-text">
            <p class="kxi-text-xlarge">{{ t('drag-and-drop') }}</p>
            <p class="kxi-text-large">{{ t('or') }}</p>
            <div class="collection-upload__upload-button-container">
              <input
                type="file"
                name="file"
                id="file"
                class="collection-upload__upload_input"
                autofocus
                #fileInput
                ng2FileSelect
                (onFileSelected)="validateSelectedFiles($event, fileInput)"
                [uploader]="uploader"
                appAutoFocus
              />
              <xi-default-button
                class="xi-default-button-text-large"
                [text]="t('upload-file')"
                buttonSize="xxlarge"
                [stretch]="true"
                (onClick)="fileInput.click()"
              >
              </xi-default-button>
            </div>
            <div class="collection-upload__horizontal-line"></div>
            <div class="collection-upload__upload-notes">
              <p>{{ t('your-files-must-be-smaller') }}:</p>
              @for (item of maxFileSizeOverrides | keyvalue; track item) {
                <p>{{ item.value }}{{ t('mb-for') }} {{ item.key }}</p>
              }
              <p>{{ maxFileSizeMB }}{{ t('mb-for-other') }}.</p>
              <p>{{ t('you-can-save-excel-files-as-csv') }}.</p>
              <p>{{ t('for-help-please-contact') }} support&#64;lexalytics.com</p>
            </div>
          </div>
        </div>
      </div>
    }
    @if (uploader?.queue?.length > 0 && !lastErrorMessage) {
      <div class="collection-upload__uploading">
        <div class="collection-upload__upload-progress-label">{{ t('uploading') }}</div>
        <table class="collection-upload__uploading-table">
          <tbody>
            @for (item of uploader.queue; track item) {
              <tr>
                <td class="collection-upload__upload-progress-spinner">
                  <mat-progress-spinner
                    class="margin-auto-0"
                    color="primary"
                    diameter="293"
                    strokeWidth="10"
                    mode="determinate"
                    [value]="item.progress"
                  >
                  </mat-progress-spinner>
                  <div class="collection-upload__upload-file-name">{{ item?.file?.name }}</div>
                  <div class="collection-upload__upload-file-info">
                    {{ item?.file?.size | bytes }}
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @if (uploader?.queue?.length > 0) {
      <div>
        @for (item of uploader.queue; track item) {
          <div>
            @if (item.isError) {
              <p>{{ lastErrorMessage }}</p>
            }
          </div>
        }
      </div>
    }
  </div>
</ng-container>
